import angular from 'angular';
import { Services } from '@Shared.Angular/@types/services';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import { SharedAngular } from '@Angular.Runner/@types/sharedAngular';
import { FlowinglyPermissions } from './flowingly.constants';

export class RouteAppConfigService {
  private routeConfigMapping: { [key: string]: () => boolean };

  constructor(
    private APP_CONFIG: Services.APP_CONFIG,
    private $state: angular.ui.IStateService,
    private permissionsService: SharedAngular.PermissionsService
  ) {
    this.routeConfigMapping = this.getRouteConfigMapping();
  }

  handleRouteAvailability(route: string): boolean {
    const checkAvailability = this.routeConfigMapping[route];
    const isAvailable = checkAvailability ? checkAvailability() : true;

    if (isAvailable) {
      return true;
    }

    const fallbackRoute = this.getFallbackRoute();
    this.$state.go(fallbackRoute);

    return false;
  }

  private getRouteConfigMapping(): { [key: string]: () => boolean } {
    return {
      [STATE_MAPPINGS.flowsactive]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.flowstodo]: () =>
        this.APP_CONFIG.allowWorkflow &&
        this.permissionsService.currentUserHasPermission(
          FlowinglyPermissions.TODO_ACCESS
        ),
      [STATE_MAPPINGS.flowsin]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.libraryworkflows]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.exagoSingle]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.exago]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.processmapsv2]: () => this.APP_CONFIG.allowProcessMap,
      [STATE_MAPPINGS.libraryprocessmaps]: () => this.APP_CONFIG.allowProcessMap
    };
  }

  private getFallbackRoute(): string {
    const defaultHomePageKey = this.APP_CONFIG.defaultHomePage;
    const defaultHomePageAllowedCheck =
      this.routeConfigMapping[STATE_MAPPINGS[defaultHomePageKey]];
    const isDefaultHomePageAllowed = defaultHomePageAllowedCheck
      ? defaultHomePageAllowedCheck()
      : true;

    let fallbackRoute: string;

    if (isDefaultHomePageAllowed) {
      fallbackRoute = STATE_MAPPINGS[defaultHomePageKey];
      if (fallbackRoute) {
        return fallbackRoute;
      }
    }

    if (this.APP_CONFIG.allowWorkflow) {
      fallbackRoute = STATE_MAPPINGS.flowsactive;
    } else if (this.APP_CONFIG.allowProcessMap) {
      fallbackRoute = STATE_MAPPINGS.processmapsv2;
    } else {
      fallbackRoute = STATE_MAPPINGS.procedures;
    }

    return fallbackRoute;
  }
}

angular
  .module('flowingly.services')
  .factory('routeAppConfigService', [
    'APP_CONFIG',
    '$state',
    'permissionsService',
    (
      APP_CONFIG: SharedAngular.APP_CONFIG,
      $state: angular.ui.IStateService,
      permissionsService: SharedAngular.PermissionsService
    ) => new RouteAppConfigService(APP_CONFIG, $state, permissionsService)
  ]);

export type RouteAppConfigServiceType = InstanceType<
  typeof RouteAppConfigService
>;
